var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTriangleWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2213_25078)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.636 2.6025C9.49894 2.38321 9.25859 2.25 9 2.25C8.74141 2.25 8.50105 2.38321 8.364 2.6025L0.864002 14.6025C0.719501 14.8337 0.711849 15.1251 0.844018 15.3636C0.976188 15.602 1.22736 15.75 1.5 15.75H16.5C16.7726 15.75 17.0238 15.602 17.156 15.3636C17.2882 15.1251 17.2805 14.8337 17.136 14.6025L9.636 2.6025ZM9 6.75C9.33137 6.75 9.6 7.01863 9.6 7.35V10.9125C9.6 11.2439 9.33137 11.5125 9 11.5125C8.66863 11.5125 8.4 11.2439 8.4 10.9125V7.35C8.4 7.01863 8.66863 6.75 9 6.75ZM9.75 12.8625C9.75 13.2767 9.41421 13.6125 9 13.6125C8.58579 13.6125 8.25 13.2767 8.25 12.8625C8.25 12.4483 8.58579 12.1125 9 12.1125C9.41421 12.1125 9.75 12.4483 9.75 12.8625Z",
    fill: "#E6001C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2213_25078"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangleWarning);
export default __webpack_public_path__ + "static/media/triangle-warning.3dd0c986bca5dbf6d39141f8376a8e15.svg";
export { ForwardRef as ReactComponent };